import { Criteria, RangeSet } from '../../shared/interfaces/quota.interface';

export class SurveyQuotaCriterion {
  constructor(private readonly _criterion: Criteria) {}

  public qualificationCode(): number {
    return this._criterion.qualification_code;
  }

  public isRange(): boolean {
    return !!this._criterion.range_sets?.length;
  }

  public range(): RangeSet[] {
    return this._criterion.range_sets || [];
  }

  public conditions(): string[] {
    return this._criterion.condition_codes || [];
  }

  public conditionNames(): string[] {
    return this._criterion.condition_names || [];
  }

  public groupName(): string {
    return this._criterion.group_name || '';
  }

  public childAgeUnit(): number | undefined {
    return this._criterion.child_age_unit;
  }
}
